import { IPublicClientApplication } from '@azure/msal-browser';
import { ProgramDate } from '../../models';
import { ApiEndpointCallStatesStore } from '../api-endpoint-call-states-store';
import { FetchContext } from '../fetch-context';
import { promiseWithObservableState } from '../promise-with-observable-state';
import { withApiAccessToken } from '../with-api-access-token';
import { getProgramDates, getProgramDatesForStaff, updateProgramDate } from './index';

export const createProgramDatesApiEndpoints = (
  fetchContext: FetchContext,
  apiEndpointCallStates: ApiEndpointCallStatesStore,
) => ({
  getProgramDates: (instance: IPublicClientApplication, startDate: string, endDate?: string, dateTypeCode?: string) => promiseWithObservableState(
    withApiAccessToken(
      instance,
      (accessToken) => getProgramDates(fetchContext, startDate, endDate, dateTypeCode, accessToken),
    ),
    (isInFlight) => {
      apiEndpointCallStates.setIsInFlight('getProgramDates', isInFlight);
    },
  ),
  getProgramDatesForStaff: (instance: IPublicClientApplication, programId: number) => promiseWithObservableState(
    withApiAccessToken(
      instance,
      (accessToken) => getProgramDatesForStaff(fetchContext, programId, accessToken),
    ),
    (isInFlight) => {
      apiEndpointCallStates.setIsInFlight('getProgramDatesForStaff', isInFlight);
    },
  ),
  updateProgramDate: (instance: IPublicClientApplication, programId: number, programDate: ProgramDate) => promiseWithObservableState(
    withApiAccessToken(
      instance,
      (accessToken) => updateProgramDate(fetchContext, programId, programDate, accessToken),
    ),
    (isInFlight) => {
      apiEndpointCallStates.setIsInFlight('updateProgramDate', isInFlight);
    },
  ),
});
